'use client';
import React from 'react';
import Link from 'next/link';
import { Edit3, Upload } from 'lucide-react';

export default function WorkerQuickActions() {
  return (
    <div className="flex items-center gap-2">
      <Link
        href="/worker-dashboard"
        className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-xl border border-border text-sm font-semibold hover:bg-muted transition-colors"
        style={{ color: 'var(--navy)' }}
      >
        <Upload size={15} />
        Upload docs
      </Link>
      <Link
        href="/worker-dashboard"
        className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold transition-all duration-150 active:scale-95"
        style={{ background: 'var(--primary)', color: 'white' }}
      >
        <Edit3 size={15} />
        Edit profile
      </Link>
    </div>
  );
}